import { DateTime } from 'luxon';
DateTime.local().setLocale("fr");

export const toDateTime = (d: Date | DateTime | string | number): DateTime => {

  if( ! d) {
    return null;
  }

  if (d instanceof Date) {
    return DateTime.fromJSDate(d);
  } else if (typeof d === "string") {
    return DateTime.fromISO(d);
  } else if (typeof d === "number") {
    return DateTime.fromMillis(d);
  } else if(isDateTime(d)){
    return d;
  }

  throw new Error(`toDateTime : Unable to parse date value ${d}`);
};

function isDateTime(x: Date | DateTime | string | number) : x is DateTime {
  return x.isLuxonDateTime  === true;
}
